export default "__VITE_ASSET__Cw_GgD14__"